import React from 'react';

const LeadingWaySection = () => {
  return (
    <div className="w-full max-w-6xl mx-auto py-20 px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
        
        {/* Left Column - Title */}
        <div className="space-y-4">
          <h2 className="text-3xl lg:text-4xl xl:text-5xl text-[#113861] leading-tight mb-4 sm:mb-6 md:mb-8 lg:mb-10">
            <span className="text-[#113861] font-source italic font-regular">Leading</span>{' '}
            <span className="text-[#113861] font-light font-source">the way</span>
            <br />
            <span className="text-[#113861] font-light font-source">forward...</span>
          </h2>
          
          {/* Left Column Paragraph */}
          <p className="text-lg lg:text-xl text-[#113861] font-sans font-regular leading-relaxed max-w-sm ">
            Analytical Prism was created with a singular purpose, to help young minds see themselves clearly through the lens of applied psychology.
          </p>
        </div>

        {/* Right Column - Content */}
        <div className="space-y-6 lg:space-y-8">
          
          {/* First Paragraph */}
          <div className="space-y-4">
            <p className="text-md lg:text-md text-[#2b2b2b] font-sans font-regular leading-relaxed">
              In a world cluttered with information and expectation, students often struggle with self-doubt, indecision, and comparison. Analytical Prism brings science, simplicity, and sensitivity together to decode human behaviour and enable self-discovery.
            </p>
          </div>

          {/* Second Paragraph */}
          <div className="space-y-4">
            <p className="text-md lg:text-md text-[#2b2b2b] font-sans font-regular leading-relaxed">
              Our tools are designed to build Clarity, the emotion that drives confidence, direction, and purpose, while being deeply rooted in cultural intelligence, ensuring relevance and resonance in the Indian context.
            </p>
          </div>

          {/* Third Paragraph */}
          <div className="space-y-4">
            <p className="text-md lg:text-md text-[#2b2b2b] font-sans font-regular leading-relaxed">
              We believe that self-awareness must be culturally grounded to be truly transformative. By partnering with universities, Analytical Prism aims to become a trusted companion in every student's journey from aspiration to actualisation.
            </p>
          </div>

        </div>
        
      </div>
    </div>
  );
};

export default LeadingWaySection;